import React from 'react';
import PropTypes from 'prop-types';
import { ListRowContent, MenuTrigger } from 'next/components/ui';
import { AccountMenuTrigger, CaretIcon, GearIcon } from './styled';

const AccountMenuButton = ({ company, name, open, ...unhandledProps }) => (
  <MenuTrigger asChild>
    {/* eslint-disable-next-line react/jsx-props-no-spreading */}
    <AccountMenuTrigger role="button" open={open} {...unhandledProps}>
      <ListRowContent
        description={name}
        prefix={<GearIcon icon="cog" />}
        suffix={<CaretIcon icon="angle-right" />}
        title={`${name} (${company})`}
      >
        {company}
      </ListRowContent>
    </AccountMenuTrigger>
  </MenuTrigger>
);

AccountMenuButton.propTypes = {
  company: PropTypes.string,
  name: PropTypes.string,
  open: PropTypes.bool,
};

export default AccountMenuButton;
